// extracted by mini-css-extract-plugin
module.exports = {"root":"SendReceipts_root__1jsxb","buttons":"SendReceipts_buttons__2kRkQ","email":"SendReceipts_email__cTOWB","bookApptTitle":"SendReceipts_bookApptTitle__1bsS-"};